import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
import { Spinner, Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
const UnlinkView = ({ viewType, unlinkedItemId, unlinkType }) => {
  const { getLabel, getFormattedLabel } = useIntl();
  const titleLabel = viewType === "success" ? `account.${unlinkType}.success.title` : `account.${unlinkType}.title`;
  if (!viewType) {
    return /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") });
  } else {
    return /* @__PURE__ */ React.createElement("div", { className: "unlink-view", "data-t": "unlink-view" }, /* @__PURE__ */ React.createElement(Heading, { variant: "small", component: "h1", className: "unlink-view__title" }, getLabel(titleLabel)), viewType === "success" && /* @__PURE__ */ React.createElement("p", null, getFormattedLabel(`account.${unlinkType}.success.message`, {
      labelData: { unlinkedItemId },
      parseLink: true
    })), viewType === "failed" && /* @__PURE__ */ React.createElement(
      Alert,
      {
        variant: "error",
        title: getLabel(`account.${unlinkType}.error.title`),
        className: "alert-m-default"
      },
      getFormattedLabel(`account.${unlinkType}.error.message`, {
        labelData: { unlinkedItemId },
        parseLink: true
      })
    ));
  }
};
export {
  UnlinkView as default
};
//# sourceMappingURL=UnlinkView.js.map
